// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2vAVr","choiceBoxes":"toolbarselects_choiceBoxes__29ETC","simpleField":"toolbarselects_simpleField__SiH2R"};